module.exports = __webpack_public_path__ + "img/37-3GK.ab7d9c6.jpg";